export default "__VITE_PUBLIC_ASSET__8b402abc__"